import { render, staticRenderFns } from "./CrewsDashlet.vue?vue&type=template&id=5f5ac3c8"
import script from "./CrewsDashlet.vue?vue&type=script&lang=js"
export * from "./CrewsDashlet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports